import React from "react";
import { Link } from "react-router-dom";
import { blog_data } from "../../data/data";

function BlogList() {
  return (
    <section className="home-header blog-list">
      <h1 className="heading-name"></h1>
      <div className="blog-list-container">
        {blog_data.map((post) => (
          <div key={post.id} className="blog-list-item">
            <Link to={`/blog/${post.slug}`} className="blog-link">
              <h2>{post.title}</h2>
            </Link>
            <small className="blog-date">Last updated: {post.date}</small>
            <p className="blog-excerpt">{post.excerpt}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default BlogList;
